import { Grid, Stack } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { getClasses } from "@/services/class";
import { Title } from "@/components/Title";
import { AllBranchSelect } from "@/components/AllBranchSelect";
import { useCurrentUser } from "@/features/authentication/contexts/AuthenticationContext";

import { ClassCard } from "../../components/ClassCard";

import type { SelectChangeEvent } from "@mui/material";

const QUERY_KEY = "classes";

export function ClassListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    homeBranchId,
    fitnessCenter: { branches },
  } = useCurrentUser();

  const branchId = useMemo(
    () => searchParams.get("branchId") ?? homeBranchId.toString(),
    [searchParams, homeBranchId],
  );

  const { data: raw } = useQuery([QUERY_KEY, branchId], () => getClasses());

  const title = "คลาสทั้งหมด";
  const data = raw ?? [];
  const isShowBranch = branches.length > 1;

  const onChangeBranch = (event: SelectChangeEvent<number>) => {
    searchParams.set("branchId", event.target.value.toString());
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <Stack
      my={{ xs: 5, sm: 10 }}
      gap={{ xs: 4, sm: 7 }}
      px={{ xs: 3, sm: 6, md: 8 }}
      alignItems="center"
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Title title={title} />
      {isShowBranch && (
        <AllBranchSelect
          value={+branchId}
          onChange={onChangeBranch}
          FormControlProps={{ sx: { width: "100%", maxWidth: 428 } }}
        />
      )}
      <Grid container spacing={{ xs: 2, sm: 4, md: 5 }} alignItems="stretch">
        {data.map((item) => (
          <Grid item xs={6} md={4} lg={3} key={item.id}>
            <ClassCard data={item} branchId={+branchId} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
